import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<ConfigEditor @config={{@model}} />\n",{ moduleName: "bullitt-time-live/templates/event/config-editor.hbs" })